/* eslint-disable */
export default {
  eula: 'Contrato de licencia de usuario final',
  eulaAbbr: 'CLUF',
} as const;

// @key: @#@"eula"@#@ @source: @#@"End User License Agreement"@#@
// @key: @#@"eulaAbbr"@#@ @source: @#@"EULA"@#@
